import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * SEÇİLİ TESLİMAT BÖLGESİ
 *
 * Tüm site aynı seçimi paylaşır: kullanıcı ürün detayında bölgeyi
 * değiştirirse ana sayfadaki "bugün teslim" göstergeleri de anında tutarlı
 * hale gelir (TanStack Query anahtarları bölgeyi içerir).
 *
 * Bölge seçilmemişse backend ilk aktif bölgeyi varsayılan kabul eder;
 * frontend varsayılan bir bölge adı uydurmaz.
 */
interface ZoneState {
  /** Kullanıcının açıkça seçtiği bölge slug'ı; yoksa backend varsayılanı. */
  zoneSlug: string | null;
  /** Kullanıcı bir kez seçim yaptı mı? Nazik bir hatırlatma göstermek için. */
  hasChosen: boolean;
  setZone: (slug: string) => void;
  clearZone: () => void;
}

export const useZoneStore = create<ZoneState>()(
  persist(
    (set) => ({
      zoneSlug: null,
      hasChosen: false,
      setZone: (slug) => set({ zoneSlug: slug, hasChosen: true }),
      clearZone: () => set({ zoneSlug: null, hasChosen: false }),
    }),
    { name: 'hc.zone' },
  ),
);

/** Query anahtarlarında kullanılır: undefined ise backend varsayılanı geçerli. */
export function useZoneSlug(): string | undefined {
  return useZoneStore((state) => state.zoneSlug) ?? undefined;
}
